import FormItem from "@components/formItem";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems";
import { getUser } from "@utils";
import React, { Fragment } from "react";
import MaskInput from "react-maskinput";
import { Box, Content, ContentTitle, MaskedInput, MaskedInputLabel } from "../baseItems";
import Base from "./base";

export default class CryptoPayment extends Base {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			isWalletMaskVisible: false,
			account: "",
			accountValue: "",
			canForward: false,
		};
		this.walletInputRef = React.createRef();
	}

	componentDidMount() {
		this.checkRequiredFields();
		super.componentDidMount();
		// const { selectedWithdraw } = this.props;
		// this.setState({ selectedCurrency: selectedWithdraw?.currencies[0]?.currency || "" });
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevState.account !== this.state.account ||
			prevState.accountValue !== this.state.accountValue ||
			prevState.stake !== this.state.stake ||
			prevState.selectedCurrency !== this.state.selectedCurrency
		) {
			this.checkRequiredFields();
		}
	}

	handleFocus = (field) => {
		this.setState({ [field]: true });
	};

	handleBlur = (field, value) => {
		const cleanedValue = value.replace(/_/g, "").trim();
		const isEmptyOrMasked = cleanedValue === "";
		this.setState(
			{
				[field]: false,
				[`${field.replace("is", "").toLowerCase()}Value`]: isEmptyOrMasked
					? ""
					: cleanedValue,
			},
			this.checkRequiredFields
		);
	};

	onEnterValue = (field, e) => {
		const value = e.target.value.replace(/_/g, "").trim();
		this.setState({ [field]: value, [`${field}Value`]: value }, this.checkRequiredFields);
	};

	checkRequiredFields = () => {
		const { accountValue, stake, selectedCurrency } = this.state;

		if (accountValue && stake && selectedCurrency) {
			this.setState({ canForward: true });
		} else {
			this.setState({ canForward: false });
		}
	};

	getStep1(translate) {
		const { stake, selectedCurrency, isWalletMaskVisible, account, accountValue } = this.state;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<BoxWrapper>
					<Fragment>
						<FormItem onRegister={() => this.registerField({ name: "account" })}>
							<Box>
								<MaskedInput>
									<MaskInput
										ref={this.walletInputRef}
										onFocus={() => this.handleFocus("isWalletMaskVisible")}
										onBlur={(e) =>
											this.handleBlur("isWalletMaskVisible", e.target.value)
										}
										maskChar={isWalletMaskVisible ? "_" : ""}
										mask="******************************************"
										size={42}
										alwaysShowMask={window.IS_MARS ? true : false}
										onChange={(e) => this.onEnterValue("account", e)}
										value={isWalletMaskVisible ? account : accountValue}
									/>
									<MaskedInputLabel
										isFocused={isWalletMaskVisible}
										hasValue={accountValue}>
										{translate("WALLET_ADDRESS")}
									</MaskedInputLabel>
								</MaskedInput>
							</Box>
						</FormItem>
					</Fragment>
				</BoxWrapper>
			</Content>
		);
	}

	goForward(step) {
		const { stake, selectedCurrency } = this.state;
		const { selectedWithdraw } = this.props;

		if (!this.state.canForward) return;

		const currency = selectedWithdraw.currencies.find(
			(item) => item.currency === selectedCurrency
		);

		if (currency && stake < currency.withdraw.min) {
			this.props.showAlert({
				type: "error",
				msg: "STAKE_RANGE_WARNING_MIN",
				title: "ERROR",
			});
			return;
		}

		if (currency && stake > currency.withdraw.max) {
			this.props.showAlert({
				type: "error",
				msg: "STAKE_RANGE_WARNING_MAX",
				title: "ERROR",
			});
			return;
		}

		const newStep = step + 1;
		this.setState({ currentStep: newStep });
	}

	makeExternalPayment() {
		const { stake, accountValue, selectedCurrency } = this.state;
		const { cryptoCurrency } = this.props;
		let withdrawData = {
			type: "CryptoPayment",
			username: getUser().username,
			language: this.getActiveLanguageCode(),
			amount: {
				value: Number(stake),
				currency: selectedCurrency ? selectedCurrency : "EUR",
			},
			cryptoCurrencyType: cryptoCurrency,
			address: accountValue,
			note: new Date(),
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}

	render() {
		const { canForward } = this.state;
		return super.render();
	}
}
